<template>
  <div>
    <a-modal
      title="草稿箱"
      :visible="draftsVisible"
      @ok="draftsModalHandleOk"
      @cancel="hideDraftsModal"
      :footer="null"
      width="664px"
      :bodyStyle="{ padding: 0 }"
    >
      <drafts-table
        :tableList="tableList"
        :cacheData="cacheData"
        :getListTaskByPage="getListTaskByPage"
        :listTotal="listTotal"
      />
      <div class="modal-footer">
        <a-button @click="hideDraftsModal">关闭</a-button>
      </div>
    </a-modal>
  </div>
</template>
<script>
import draftsTable from "./draftsTable";
import api from '../../commomFun/api.js'
import moment from 'moment'
export default {
  props: {
    draftsVisible: Boolean
  },
  data () {
    return {
      visible: false,
      tableList: [],
      cacheData: [],
      listTotal: 10
    };
  },
  components: {
    draftsTable
  },

  methods: {
    // 获取草稿箱数据
    getListTaskByPage (pageNum) {
      api.getApi_header("/draft/plan/list", {
        pageNum: pageNum,
        pageSize: 5
      }).then(res => {
        if (res.code === 200) {
          const { data } = res;
          this.cacheData = (data.list || []).map(item => {
            let planInfo = {}
            let devInfo = {}
            try {
              planInfo = JSON.parse(item.planInfo)
              devInfo = JSON.parse(item.devInfo)
            } catch {
              planInfo = {}
              devInfo = {}
            }
            item.planInfo = planInfo
            item.devInfo = devInfo
            return item
          })
          this.createTableData(data)
          this.listTotal = res.data.total
        }
      });
    },
    createTableData (data) {
      this.tableList = (data.list || []).map((item, key) => {
        return {
          key: item.draftId,
          planName: item.planName,
          saveTime: moment(item.updateTime).format('YYYY/MM/DD HH:mm:ss'),
          editable: false
        }
      })
    },
    draftsModalHandleOk () {
      this.$parent.draftsVisible = false;
    },
    hideDraftsModal () {
      this.$parent.draftsVisible = false;
    },

  }
};
</script>
<style lang="scss">
.ant-modal-title {
  font-weight: 500;
  font-size: 16px;
  font-family: 'PingFangSC-Medium, PingFang SC';
  color: rgba(0, 0, 0, 0.85);
  line-height: 24px;
}
.modal-footer {
  width: 100%;
  height: 52px;
  border-top: 1px solid #e8e8e8;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  box-sizing: border-box;
  padding-right: 32px;
}
</style>
